export const list = (dispatch, apiClient) => apiClient
  .call({ endpoint: 'recipe/list' })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RECIPE_SET', payload: res.data });
    return res;
  });

export const find = (dispatch, apiClient, query) => apiClient
  .call({ endpoint: 'recipe/find', data: { query } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RECIPE_SET', payload: res.data });
    return res;
  });

export const create = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'recipe/new', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RECIPE_SET', payload: res.data });
    return res;
  });

export const update = (dispatch, apiClient, id, data) => apiClient
  .call({ endpoint: 'recipe/update', data: { ...data, id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RECIPE_SET', payload: res.data });
    return res;
  });

export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'recipe/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RECIPE_SET', payload: res.data });
    return res;
  });

export const remove = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'recipe/remove', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RECIPE_SET', payload: res.data });
    return res;
  });

export const run = (dispatch, apiClient, id, runs, locationFrom, locationTo) => apiClient
  .call({ endpoint: 'recipe/run', data: { id, runs, locationFrom, locationTo } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'RAW_MATERIAL_STOCK_SET', payload: res.data.rawMaterialStock });
    dispatch({ type: 'STOCK_SET', payload: res.data.stock });
    return res;
  });




// WEBPACK FOOTER //
// ./app/actions/recipe.js